import { Pipe, PipeTransform } from '@angular/core';

const FORMATTER = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  notation: 'compact',
  maximumFractionDigits: 1,
});

/** 8647045000 → "$8.6B", 412000000 → "$412M". */
@Pipe({
  name: 'compactUsd',
  standalone: true
})
export class CompactUsdPipe implements PipeTransform {
  transform(value: number | null | undefined, fallback: string = '—'): string {
    return value === null || value === undefined ? fallback : FORMATTER.format(value);
  }
}
